"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ProductPriceInfo = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _helpers = require("@PetSureAustralia/petsure-react-ui-library/distLib/helpers");
var _quoteHelpers = require("../../helpers/quoteHelpers");
var _tableContext = require("../productsTable/stateHelpers/tableContext");
var _productHelpers = require("../../helpers/productHelpers");
var _defaults = require("../productsTable/defaults");
var _planHelpers = require("../../helpers/planHelpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ProductPriceInfo = exports.ProductPriceInfo = function ProductPriceInfo(_ref) {
  var _FREQUENCIES$paymentF;
  var _ref$contentToggleabl = _ref.contentToggleable,
    contentToggleable = _ref$contentToggleabl === void 0 ? false : _ref$contentToggleabl,
    _ref$productIsSelecte = _ref.productIsSelected,
    productIsSelected = _ref$productIsSelecte === void 0 ? false : _ref$productIsSelecte,
    planNumber = _ref.planNumber,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$plansVisible = _ref.plansVisible,
    plansVisible = _ref$plansVisible === void 0 ? false : _ref$plansVisible,
    _ref$onPlanSelect = _ref.onPlanSelect,
    onPlanSelect = _ref$onPlanSelect === void 0 ? function () {} : _ref$onPlanSelect,
    _ref$onTogglePlanVisi = _ref.onTogglePlanVisibility,
    onTogglePlanVisibility = _ref$onTogglePlanVisi === void 0 ? function () {} : _ref$onTogglePlanVisi,
    productName = _ref.productName;
  var _useContext = (0, _react.useContext)(_tableContext.TableContext),
    _useContext$tableCont = _useContext.tableContext,
    brand = _useContext$tableCont.brand,
    BaseProducts = _useContext$tableCont.BaseProducts,
    AllPlans = _useContext$tableCont.AllPlans,
    brandTextElements = _useContext$tableCont.brandTextElements,
    ProductGroupsKeyedByPlanNumber = _useContext$tableCont.ProductGroupsKeyedByPlanNumber,
    AddOnsMap = _useContext$tableCont.AddOnsMap,
    productsAreMerged = _useContext$tableCont.productsAreMerged,
    _useContext$tableStat = _useContext.tableState,
    dataIsUpdating = _useContext$tableStat.dataIsUpdating,
    selectedOptions = _useContext$tableStat.selectedOptions,
    productQuotes = _useContext$tableStat.productQuotes,
    quotesContext = _useContext$tableStat.quotesContext,
    mobileMode = _useContext$tableStat.mobileSettings.mobileMode;
  var _ref2 = _defaults.DefaultProductTablePriceInfo[brand] || _defaults.DefaultProductTablePriceInfo["default"],
    showBaseWithoutDiscount = _ref2.showBaseWithoutDiscount,
    showDiscountDetail = _ref2.showDiscountDetail,
    freeMonth = _ref2.freeMonth,
    showFreeMonth = _ref2.showFreeMonth,
    title = _ref2.title;
  var freeMonthDiscount = (0, _react.useMemo)(function () {
    var loadings = (0, _quoteHelpers.ExtractLoadings)({
      productQuote: productQuotes[planNumber]
    });
    return !awaitingQuote ? freeMonth({
      allLoadings: loadings
    }) : '';
  }, [productQuotes, freeMonth, awaitingQuote, planNumber]);
  var discountDescription = (0, _react.useMemo)(function () {
    var productLoadings = (0, _quoteHelpers.ExtractAllLoadings)({
      productQuotes: productQuotes
    });
    return !dataIsUpdating ? title({
      allLoadings: productLoadings
    }) : '';
  }, [productQuotes, dataIsUpdating, title]);
  if (!productQuotes[planNumber]) {
    return null;
  }
  var activeSelectedOptions = selectedOptions.merged ? selectedOptions : (0, _productHelpers.GetInitialPlanOptionsState)({
    BaseProducts: BaseProducts,
    AllPlans: AllPlans,
    brandTextElements: brandTextElements
  });

  // eslint-disable-next-line react-hooks/rules-of-hooks
  var newPlanNumber = (0, _react.useMemo)(function () {
    if (productsAreMerged) {
      var _FindMatchingPlanBase = (0, _planHelpers.FindMatchingPlanBasedOnVariants)({
          productDefinition: AllPlans["Plan_".concat(planNumber)],
          productGroup: ProductGroupsKeyedByPlanNumber["Plan_".concat(planNumber)],
          selectedOptions: activeSelectedOptions,
          AllPlans: AllPlans,
          AddOnsMap: AddOnsMap
        }),
        selectedProduct = _FindMatchingPlanBase.selectedProduct;
      return selectedProduct.planNumber;
    }
    return planNumber;
  }, [planNumber, AllPlans, activeSelectedOptions, ProductGroupsKeyedByPlanNumber, AddOnsMap, productsAreMerged]);
  var planQuote = (0, _quoteHelpers.GetQuoteForPlanVariation)({
    productQuotes: productQuotes,
    selectedPlanNumber: newPlanNumber,
    selectedOptions: activeSelectedOptions,
    productsAreMerged: productsAreMerged,
    planProductGroup: ProductGroupsKeyedByPlanNumber["Plan_".concat(planNumber)]
  });
  var _planQuote$payment = planQuote.payment,
    total = _planQuote$payment.total,
    base = _planQuote$payment.base;
  var discountAmount = base - total;
  var awaitingQuote = base === 0 || dataIsUpdating;
  var paymentFrequencyCode = quotesContext.paymentFrequencyCode,
    hasPromotionCode = quotesContext.hasPromotionCode,
    promotionCode = quotesContext.promotionCode,
    promotionMessage = quotesContext.promotionMessage;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "productPriceInfo"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "productPrice ".concat(awaitingQuote ? 'dataIsUpdating' : '')
  }, showFreeMonth && /*#__PURE__*/_react["default"].createElement("span", {
    className: "freeMonth"
  }, awaitingQuote ? '' : freeMonthDiscount), (hasPromotionCode && showBaseWithoutDiscount && discountAmount > 0 || showBaseWithoutDiscount && discountAmount > 0) && /*#__PURE__*/_react["default"].createElement("span", {
    className: "baseAmount"
  }, awaitingQuote ? '' : (0, _helpers.FormatAsCurrency)(base)), /*#__PURE__*/_react["default"].createElement("span", {
    className: "total"
  }, awaitingQuote ? '' : (0, _helpers.FormatAsCurrency)(total)), awaitingQuote && /*#__PURE__*/_react["default"].createElement(_components.Spinner, null), /*#__PURE__*/_react["default"].createElement("small", {
    className: "frequency"
  }, awaitingQuote ? '' : (_FREQUENCIES$paymentF = _quoteHelpers.FREQUENCIES[paymentFrequencyCode]) === null || _FREQUENCIES$paymentF === void 0 ? void 0 : _FREQUENCIES$paymentF.tableHeadDisplayText), (mobileMode && hasPromotionCode && showBaseWithoutDiscount && discountAmount > 0 || mobileMode && showBaseWithoutDiscount && discountAmount > 0) && /*#__PURE__*/_react["default"].createElement("small", {
    className: "frequency"
  }, awaitingQuote ? '' : discountDescription), showDiscountDetail && !awaitingQuote && hasPromotionCode && discountAmount > 0 && /*#__PURE__*/_react["default"].createElement("span", {
    className: "discount ".concat(promotionCode)
  }, "Discount has been applied", /*#__PURE__*/_react["default"].createElement(_components.Tooltip, {
    icon: "price-tag"
  }, promotionMessage))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "productsTableActions"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "selectAction"
  }, productIsSelected && !isDisabled ? /*#__PURE__*/_react["default"].createElement("button", {
    className: "button primary focus selected planSelectButton",
    type: "button",
    onClick: onPlanSelect,
    "aria-describedby": "productPlan".concat(planNumber)
  }, /*#__PURE__*/_react["default"].createElement(_components.Icon, {
    icon: "tick"
  }), !awaitingQuote && /*#__PURE__*/_react["default"].createElement("span", {
    className: "labelText"
  }, "Selected")) : /*#__PURE__*/_react["default"].createElement("button", {
    disabled: awaitingQuote,
    className: "button primary planSelectButton",
    type: "button",
    onClick: onPlanSelect,
    "aria-describedby": "productPlan".concat(planNumber)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "labelText"
  }, "Select")), /*#__PURE__*/_react["default"].createElement("span", {
    className: "sr-only",
    id: "productPlan".concat(planNumber)
  }, "".concat(productIsSelected && !isDisabled ? 'Selected' : 'Select', " ").concat(productName, " product"))), contentToggleable && mobileMode && !isDisabled && /*#__PURE__*/_react["default"].createElement("div", {
    className: "toggleAction"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "sr-only"
  }, "Hide and show product"), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: onTogglePlanVisibility
  }, /*#__PURE__*/_react["default"].createElement(_components.Icon, {
    icon: plansVisible ? 'caret_up' : 'caret_down'
  })))));
};
ProductPriceInfo.propTypes = {
  contentToggleable: _propTypes["default"].bool,
  productIsSelected: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool,
  planNumber: _propTypes["default"].number,
  plansVisible: _propTypes["default"].bool,
  onPlanSelect: _propTypes["default"].func,
  onTogglePlanVisibility: _propTypes["default"].func,
  productName: _propTypes["default"].string
};
var _default = exports["default"] = {
  ProductPriceInfo: ProductPriceInfo
};